import { StoryblokComponent, storyblokEditable } from "gatsby-source-storyblok"

import ArticleBodySection from "@components/V2/Layouts/ArticleBodySection"
import React from "react"

const StoryblokArticleBodySection = ({
  blok,
}: Storyblok.BlokProps<Storyblok.ArticleBodySection>) => {
  return (
    <ArticleBodySection
      id={blok._uid}
      title={blok.title}
      // @ts-expect-error to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    >
      {blok.content?.map((contentBlok) => (
        <StoryblokComponent key={contentBlok._uid} blok={contentBlok} />
      ))}
    </ArticleBodySection>
  )
}

export default StoryblokArticleBodySection
